// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__xVo6f","title":"ClientReferral_title__2wz_u","itemText":"ClientReferral_itemText__3TET5"};